import Header from "./Header"
import api from "views/auth/Api";
import React, { useState,useEffect } from "react";
import "../Myprojects.css";
import { MdOutlinePermMedia } from "react-icons/md";
import  { FILES_URL } from '../../../../configs/AppConfig';




const Resources = ({data}) => {
   const [resources , setResources] = useState([]);

  useEffect(() => {
              setResources(data.project?.project?.resources)
        }, [data]);
    const openPage = (resource) => {
      if (resource.type === 'HTML') {
    window.open(`${FILES_URL}${resource.url}`, "_blank"); 
      }
      else if (resource.type === 'LINK') {
        window.open(`${resource.url}`, "_blank"); 
      }
  };



  return (
       <div className="h-full w-full">
      {/* <Header /> */}
      <div className="resources-container ">
              {resources.map(resource =>
              <div 
              // onClick={() => selectSkip(resource.id)} 
              className="card-container ">
                <div className="iconH2" >
                  <MdOutlinePermMedia className="iconImg" />
                  <h2 className="h2Card">{resource.name}</h2>
                </div>
                <p className="pcard">{resource.description}</p>
                <button className="btn-card" onClick={() => openPage(resource)}>view</button>

          </div>
        )} 
        </div>
    </div>
  );
};

export default Resources;
